module.exports = __webpack_public_path__ + "img/微信图片_20241203085622-p-800.c898222d.jpg";